import styled from 'styled-components/macro'
import palette from 'src/designSystem/variables/palette'
import { GridRow } from 'src/components/Reusable/Grid'

export const MultiSelectModalRow = styled(GridRow)`
  cursor: pointer;
`

export const MultiSelectFiltersContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const MultiSelectPaginateContainer = styled.div`
  margin-left: auto;
`

export const MultiSelectStatusContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 120px;
  width: 100%;
`

export const MultiSelectStatusText = styled.p`
  margin: auto;
  text-align: center;
  color: ${palette.neutral[900]};
`
